import { useL10n } from '@uplift/hooks';
import { Box, Button, Theme, Typography, useMediaQuery } from '@mui/material';
import { ClickToCopy, StackableCard, StackableCardDeck } from '@uplift/ui-v2';
import { getProviderPublicProfileDomain } from '@uplift/utils';
import { PublicProviderProfile } from '@uplift/api';
import { InsertLinkOutlined } from '@mui/icons-material';

export type SharePublicProfileUrlProps = {
  payoutsShowing: boolean;
  profile: PublicProviderProfile;
};

export const SharePublicProfileUrl: React.FC<SharePublicProfileUrlProps> = (props) => {
  const l10n = useL10n();
  const publicProfileDomain = getProviderPublicProfileDomain();
  const isXS = useMediaQuery<Theme>(theme => theme.breakpoints.down('xs'));
  const isMD = useMediaQuery<Theme>(theme => theme.breakpoints.up('md'));
  const isTablet = !isXS && !isMD;

  return (
    <Box mb={50}>
      {!props.payoutsShowing && <Box mt={8} />}
      <StackableCardDeck direction={isTablet ? 'horizontal' : 'vertical'}>
        <StackableCard>
          <Box display="flex" flexDirection="column">
            <Typography>
              {l10n.publicProfile.share.dashboard.card.title}
            </Typography>
            <Typography variant="body2">
              {l10n.publicProfile.share.dashboard.card.description}
            </Typography>
            <Box mt={1}>
              <ClickToCopy text={`${publicProfileDomain}${props.profile.url}`} arrow copyMessage="Copy Link">
                <Button
                  fullWidth
                  variant="text"
                  color="secondary"
                  endIcon={<InsertLinkOutlined />}
                >
                  {l10n.publicProfile.share.dashboard.card.buttonText}
                </Button>
              </ClickToCopy>
            </Box>
          </Box>
        </StackableCard>
      </StackableCardDeck>
    </Box>
  );
};
